export const colorsConstants = {
    divisionColors: [
        "#97B088",
        "#2ECC71",
        "#16A085",
        "#3498db",
        "#2980b9",
        "#7f8c8d",
        "#e67e22",
        "#e74c3c",
        "#B05F6D",
        "#D33257",
        "#8A2D3C",
        "#953163",
        "#8e44ad",
        "#2c3e50",
    ],
} as const;
